import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import Well from '../Well';

import Metrics from './Metrics';
import enhancer from '../enhancer';

class Home extends Component {
  select = key => {
    switch (key) {
      case 'pendingTutors':
        // TODO
        break;
      default:
        break;
    }
  };

  render() {
    const { authenticated, admin } = this.props;

    return <Well>{authenticated ? <Metrics admin={admin} /> : null}</Well>;
  }
}

const query = graphql`
  query HomeAdminQuery {
    admin {
      ...Home_admin
    }
  }
`;

export default enhancer(Home, {
  mapStateToProps: state => ({
    authenticated: state.auth.authenticated,
  }),
  relay: {
    query,
    create: () =>
      createFragmentContainer(Home, {
        admin: graphql`
          fragment Home_admin on Admin {
            ...Metrics_admin
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/components/home/Home.js